
import { Component, OnInit, ViewChild, ElementRef, HostListener, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router, RoutesRecognized } from '@angular/router';
import { ProductConsts } from '../../constants';
import { ProductService } from '../../services/product.service';
import { StatePersistService } from 'src/app/core/services/state-persist.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AlertService } from 'src/app/core/services/alert.service';
import { CartService } from 'src/app/cart/services/cart.service';
import { Location } from '@angular/common';
import { filter, pairwise } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';
import { SharedConsts } from 'src/app/shared/constants';

@Component({
    selector: 'product-detail',
    templateUrl: './product-detail.component.html',
    styleUrls: ['./product-detail.component.scss'],
    standalone: false
})
export class ProductDetailComponent implements OnInit {
  bsModalRef: BsModalRef;
  productId: any;
  constants = ProductConsts
  product: any;
  global_data:any = {};
  qyt = 1;
  selectedStore: any;
  miniCartDetails: any;
  delistMessage = '';
  popupMessage = '';
  commonButtonText = 'Ok';
  removeProduct: any;
  removeHeading = ''
  cartButtonText = 'Add'
  previous_url = ''
  constructor(private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private productService: ProductService,
    private statePersist:StatePersistService,
    private router: Router,
    private modalService: BsModalService,
    private alertService: AlertService,
    private cartService: CartService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private location: Location) { 
      this.router.events
    .pipe(filter((evt: any) => evt instanceof RoutesRecognized), pairwise())
    .subscribe((events: RoutesRecognized[]) => {
      this.previous_url = events[0].urlAfterRedirects
      this.statePersist.setLocalStorage('previous_url', this.previous_url)
    });
    }

  ngOnInit(): void {
    this.statePersist.watchGlobalDataStorage().subscribe(message => {
      this.global_data = this.statePersist.getLocalStorage('global_data')
    })
    this.titleService.setTitle(ProductConsts.PRODUCT_DETAIL_PAGE_TITLE);
    this.selectedStore = this.statePersist.getLocalStorage('selectedStoreAddress')
    this.miniCartDetails = this.statePersist.getLocalStorage('mini_cart_details')
    this.statePersist.watchMiniCartDetailChange().subscribe(message => {
      this.miniCartDetails = this.statePersist.getLocalStorage('mini_cart_details')
    })
    this.statePersist.setLocalStorage('address-disabled', true)
    this.statePersist.setLocalStorage('retailer-disabled', true)
    var productData;
    productData = this.statePersist.getLocalStorage('product_data')
    this.statePersist.setLocalStorage('product_data', {}, 'search')
    this.statePersist.setLocalStorage('product_data', productData)
    this.productId = ''
    this.productId = this.activatedRoute.snapshot.paramMap.get('productid')
    this.productDetail()

    this.statePersist.watchProductDetailPageStorage().subscribe(message => {
      this.qyt = 1;
      this.productDetail()
    })
    
  }

  goBack() {
    this.statePersist.setLocalStorage('back-to-product-listing', true)
    this.statePersist.setLocalStorage('scrollElementId', this.productId)
    window.history.back();
  }
  isNumeric(value) {
    return this.constants.NUMBER_PATTERN.test(value);
  }
  @ViewChild('stickyMenu') menuElement: ElementRef;

  sticky: boolean = true;
  elementPosition: any;
  ngAfterViewInit(){
    if (this.menuElement != undefined){
      this.elementPosition = this.menuElement.nativeElement.offsetTop;
    }
  }

  @HostListener('window:popstate', ['$event'])
  onBrowserBackBtnClose(event: Event) {
      event.preventDefault(); 
      this.statePersist.setLocalStorage('back-to-product-listing', true)
      this.statePersist.setLocalStorage('scrollElementId', this.productId)
  }

  @HostListener('window:scroll', ['$event'])
    handleScroll(){
      const windowScroll = window.pageYOffset;
      if(windowScroll >= this.elementPosition){
        this.sticky = false;
      } else {
        this.sticky = true;
      }
    }
  
  closeDelistPopup(){
    this.bsModalRef.hide()
  }
  productDetail(){
    this.productService.getProductDetail(this.productId)
    .subscribe(
      data => {
        if (data.response) {
          this.delistMessage = ''
          if (data.status == 1163){
            this.alertService.error(data.response);
            this.statePersist.setLocalStorage('product_data', {'brand_filter':''});
            this.router.navigate(['/product/listing/All']);
          }
          else{
            this.product = data.response;
            if (this.product.item_id != ''){
              this.cartButtonText = 'Update'
            }
            else{
              this.cartButtonText = 'Add'
            }
            window.scroll({ 
              top: 0, 
              left: 0, 
              behavior: 'smooth' 
            });
            this.statePersist.setLocalStorage('selectedStore', this.product)
            if (this.product.qty !== '' && this.product.qty !== undefined){
              this.qyt = parseInt(this.product.qty)
            }
          }
         
          
        }
        
      }
    );
  }

  qytChange(value, template: any){
    this.qyt = value
    this.statePersist.amendQtyGoogleanalyticsEvent()
    if (this.qyt == 0){
      this.removePopup(template, this.product)
    }
  }

  qytUpdate(){
    this.statePersist.amendQtyGoogleanalyticsEvent()
    this.productService.qytUpdate({'item_id':this.product.item_id, 'qty':this.qyt})
    .subscribe(
      data => {
        if (data.response) {
          // this.product['qyt'] = this.qyt
          if (data.status == 1169){
            this.product['qty'] = 1
            this.product['item_id'] = ''
            this.product['back_in_stock'] = '0'
            this.qyt = 1
          }
          else if(data.status == 1180){
            localStorage.setItem('closeStorInfoMessage', data.response.msg)
            document.getElementById("openclosedStoreInfo").click();
            this.qyt = data.response.qty
            this.product['qty'] = data.response.qty
            
          }
          else if (data.status == 2212){
            this.alertService.error(data.response)
            this.qyt = data.response.qty
            this.product['qty'] = data.response.qty
          }
          else if (data.status == 1163 || data.status == 2211){
            this.alertService.error(data.response);
            this.statePersist.setLocalStorage('product_data', {'brand_filter':''});
            this.router.navigate(['/product/listing/All']);
          }
          else{
            this.product['qty'] = this.qyt
            this.product['row_total'] = data.response.row_total
            this.product['margin'] = data.response.margin
            this.product['price'] = data.response.price
          }
          if (this.product.item_id != ''){
            this.cartButtonText = 'Update'
          }
          else{
            this.cartButtonText = 'Add'
          }
          this.statePersist.emitminiCartData('min cart update')
         
        }
        
      }
    );
  }

  popup(template: TemplateRef<any>){
    this.bsModalRef = this.modalService.show(template,  Object.assign({}, { class: 'modal-dialog-centered custom-modal confirm' }));
  }
  
  addToCart(template: any, template2: any,popup_24hr_template,check_last_order=true){
    this.googleAnalyticsService.eventEmitter(SharedConsts.PRODCAT_ADDTOCART_PDP_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, SharedConsts.PRODCAT_ADDTOCART_PDP_EVENT_ACTION,SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
    let dataObj;

    if (!check_last_order){
      this.bsModalRef.hide();
    }

    this.miniCartDetails = this.statePersist.getLocalStorage('mini_cart_details')
    if (this.miniCartDetails){
      if (this.miniCartDetails.items_count != '0' && this.miniCartDetails.items_count != ''){
        check_last_order = false
      }
    }
    
    dataObj = {
      "cart_item": {
      "sku": this.product.sku,
      "qty": this.qyt
       },
       "check_last_order":check_last_order,
      }
    
    this.productService.addToCart(dataObj)
    .subscribe(
      data => {
        if (data.response) {
          if (data.status == 2212) {
            this.product['qyt'] = 1
            this.qyt = 1
            this.alertService.error(data.response.msg)
          }
          else if (data.status == 1169){
            this.product['qyt'] = 1
            this.product['item_id'] = ''
            this.product['back_in_stock'] = '0'
            this.product['is_in_stock'] = '0'
            this.qyt = 1
          }
          else if(data.status == 1180){
            localStorage.setItem('closeStorInfoMessage', data.response.msg)
            document.getElementById("openclosedStoreInfo").click();
            this.product['qyt'] = 1
            this.qyt = 1

          }
          else if (data.status == 1168){
            this.product['qyt'] = 1
            this.product['item_id'] = ''
            this.product['back_in_stock'] = '0'
            this.product['is_in_stock'] = '0'
            this.qyt = 1
            this.popupMessage = data.response
            this.commonButtonText = "Ok, Don't show this again"
            this.popup(template2)
          }
          else if (data.status == 1163){
            this.alertService.error(data.response);
            this.statePersist.setLocalStorage('product_data', {'brand_filter':''});
            this.router.navigate(['/product/listing/All']);
          }
          else if (data.status == 1188) {
            this.popupMessage = data.response.split("<br>").join("\n");
            this.commonButtonText = "Confirm"
            this.popup(popup_24hr_template)
          }
          else{
            this.product['qty'] = this.qyt
            this.product['item_id'] = data.response.item_id
            this.product['row_total'] = data.response.row_total
            this.product['margin'] = data.response.margin
            this.product['price'] = data.response.price
            // if (template){
            //   this.popup(template)
            // }
            var storeCount
            storeCount = this.statePersist.getLocalStorage('selectedStoreAddress')
            if (template && storeCount['totalStoreCount'] > 1){
              this.popup(template)
            }
          }
          if (this.product.item_id != ''){
            this.cartButtonText = 'Update'
          }
          else{
            this.cartButtonText = 'Add'
          }
          this.statePersist.emitminiCartData('min cart update')
         
        }
        
      }
    );
  }

  removePopup(template: TemplateRef<any>, selectedProduct) {
    this.removeProduct = selectedProduct
    this.removeHeading = 'Are you sure you want to remove product from cart?'
    let config;
    config = {
      backdrop: true,
      ignoreBackdropClick: true
    };
  
    this.bsModalRef = this.modalService.show(template,  Object.assign({}, { class: 'modal-dialog-centered custom-modal confirm' }, config));
  }

  cancleRequest(){
    this.qyt = parseInt(this.product.qty)
    this.bsModalRef.hide()
  }

  removeItem(product){
    let fordata;
    fordata = {'item_id': product.item_id}
    this.bsModalRef.hide();
    this.cartService.removeItem(fordata)
      .subscribe(
        data => {
          if (data.response) {
            if(data.status == 1180){
              localStorage.setItem('closeStorInfoMessage', data.response.msg)
              document.getElementById("openclosedStoreInfo").click();
              const currentUrl = this.router.url;
              this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                this.router.navigate([currentUrl]);
              });
            }
            else if (data.status == 2212){
              this.alertService.error(data.response)
            }
            else if (data.status == 2211){
              this.alertService.error(data.response);
              this.statePersist.setLocalStorage('product_data', {'brand_filter':''});
              this.router.navigate(['/product/listing/All']);
            }
            else{
              this.bsModalRef.hide();
              this.qyt = 1
              this.product.qty = '1'
              this.product.back_in_stock= ''
              this.product.item_id = ''
              this.product.row_total = ''
              this.statePersist.emitminiCartData('update mini cart')
              this.alertService.success('Product removed.')
              this.cartButtonText = 'Add'
            }
            
            
          }
            
          }

      )

  }
  

}
